import React from 'react'
import { Link, useHistory } from 'react-router-dom'

import './styles.css'

// define um card pequeno para ser usado em um produto
// parametros: title, color, image, url e external_link
const SmallCard = ({title, color, image, url, external_link=false}) => {
    let history = useHistory();

    const RedirectPortalPage = () => {
        history.push(url);
    }

    const RedirectExternalPage = () => {
        window.open(url);
    }

    return (
        <div>
            {!external_link ?
                <div className="small-card-container" style={{"background": color}} onClick={RedirectPortalPage}>
                    <Link to={url} className="small-card-title">{title}</Link>
                    <img className="small-card-img" src={image} />
                </div>
                :
                <div className="small-card-container" style={{"background": color}} onClick={RedirectExternalPage}>
                    <Link to={{ pathname: url }} className="small-card-title" target="_blank">{title}</Link>
                    <img className="small-card-img" src={image} />
                </div>
            }
        </div>
    );
}


export default SmallCard;